<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  created () {
    console.log(`%c version %c ${process.env.VUE_APP_VERSION} %c`, 'background: #35495e; padding: 1px; border-radius: 2px 0 0 2px; color: #fff;', 'background: #409EFF; padding: 1px; border-radius: 0 2px 2px 0; color: #fff;', 'background: transparent;')
  },

  watch: {
    '$route.query.mm': {
      immediate: true,
      handler (mm) {
        if (process.env.VUE_APP_SITE === 'ae') {
          const { token } = this.$route.query
          const orinText = token + 'ufb'
          // const totalNum = mm.substr(mm.length - 3, mm.length)
          const originMM = mm.substr(0, mm.length - 3)
          // const mmTotalNum = this.HexAdd(originMM)
          // if (mmTotalNum !== parseInt(totalNum)) {
          //   this.SET_FULL_MASK_ON('IdlePage')
          // }
          if (CryptoJS.SHA1(orinText).toString() === originMM) {
            document.querySelector('link').setAttribute('href', './favicon/ufa/http://10.26.26.103:8080/.ico')
            document.title = 'UFA LOTTO'
          } else {
            document.title = 'AE LOTTO'
          }
        } else document.title = process.env.VUE_APP_SITE_TITLE
      }
    }
  },

  methods: {
    HexAdd (mm) {
      let num = 0
      mm.split('').forEach(word => {
        num += parseInt(word, 16)
      })
      return num
    }
  }
}
</script>

<style lang="stylus">
body.area-limit
  background-color #230034

body.maintenance
  background-color #FFF

#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  color #2c3e50
</style>
